import { useSelector } from 'react-redux';

export const MOBILE = 768;

const useScreenSize = () => {
  const { width } = useSelector((c) => c.settings ?? {});

  const isMobile = width <= MOBILE;

  return { isMobile, width };
};

export default useScreenSize;
